import { o_util } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const toggle = /*           */ asExport(o_util, "toggle", noop);
const get = /*           */ asExport(toggle, "get", noop);
const getToggle = /*           */ asExport(toggle, "getToggle", noop);
export {
  get,
  getToggle,
  toggle
};
/*                                      */
